import {
  initialState,
  Actions,
  State,
  GET_USER_CUSTOMIZATION,
  GET_USER_CUSTOMIZATION_SUCCESS,
  GET_USER_CUSTOMIZATION_ERROR,
} from '../../types/user/customization';

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_USER_CUSTOMIZATION:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          success: false,
          error: false,
        },
      };
    case GET_USER_CUSTOMIZATION_SUCCESS:
      return {
        ...state,
        data: JSON.parse(JSON.stringify(action.payload)),
        states: {
          loading: false,
          success: true,
          error: false,
        },
      };
    case GET_USER_CUSTOMIZATION_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          success: false,
          error: action.payload,
        },
      };
    default:
      return { ...state };
  }
};

export default reducers;
